module.exports = __webpack_public_path__ + "static/media/fa-regular-400.c4f508e7.woff";